import { useTheme } from '@h2oai/ui-kit';

import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';

export interface StatsCardProps {
  title: string;
  stat: string | number;
  linkHref?: string;
  isLoading?: boolean;
}

const StatsCard = (props: StatsCardProps) => {
  const theme = useTheme(),
    palette = theme.palette;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: palette?.white,
        height: 100,
        width: 168,
        borderRadius: 4,
        padding: 16,
      }}
    >
      <span style={{ color: palette?.gray500 }}>{props.title}</span>
      <span
        style={{
          color: palette?.gray900,
          fontWeight: 500,
          fontSize: 28,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
        }}
      >
        {props.isLoading ? <SkeletonLoader width={40} height={34} /> : props.stat}
      </span>
    </div>
  );
};

export default StatsCard;
